class CollectionTabsViewAll extends HTMLElement {
  connectedCallback() {
    this.link = this.querySelector('[data-view-all]');
    if (!this.link) return;
    this.addEventListener('click', this.handleSelect);
    this.addEventListener('keydown', this.handleKey);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleSelect);
    this.removeEventListener('keydown', this.handleKey);
  }

  handleSelect = (event) => {
    const tab = event.target.closest('[data-tabs-name]');
    if (tab) this.update(tab);
  };

  handleKey = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const tab = event.target.closest('[data-tabs-name]');
    if (tab) this.update(tab);
  };

  update(tab) {
    const url = tab.dataset.collectionUrl;
    if (url) this.link.href = url;
  }
}

if (!customElements.get('collection-tabs-view-all')) {
  customElements.define('collection-tabs-view-all', CollectionTabsViewAll);
}
